import * as Sentry from '@sentry/react';
import { logEvent } from '../lib/monitoring';

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div className="min-h-screen bg-gray-900 flex items-center justify-center">
          <div className="glass-card p-8 rounded-lg max-w-lg text-center">
            <h2 className="text-2xl font-bold text-white mb-4">Something went wrong</h2>
            <p className="text-gray-300 mb-4">
              We've been notified and will fix this as soon as possible.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Refresh Page
            </button>
          </div>
        </div>
      )}
      onError={(error) => {
        logEvent({
          level: 'error',
          message: error.message,
          metadata: {
            stack: error.stack,
            url: window.location.href,
          },
        });
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}